import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './About.css';
import * as icons from '../icons/Icons';

export default function About() {

  const navigate = useNavigate();
  const [contactladiestext, setContactladiestext] = useState("Contact me but for ladies only 😉");

  const checkladiesclick = () => {
    if (contactladiestext === "I said ladies only 😤") {
      setContactladiestext("Alright you win, contact me then!");
      setTimeout(() => {
      navigate('/contact');
      }, 2000);
    }
    else {
      setContactladiestext("I said ladies only 😤");
    }
  };

  return (
    <motion.div className="about-page" initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -14 }} transition={{ duration: 0.25 }}>

      <section className="about-hero">
        <div className="about-hero-glow" />
        <div className="container">
          <h1 className="about-title">
            About <span className="accent">Me</span>
          </h1>
          <p className="about-intro">
            I am <strong>Jaylano van der Veen</strong>, an entry-level software developer
            from <strong>Almeloooooooooo</strong>. I combine my programming knowledge with design skills to
            build fast, modern web applications and more.
          </p>
          <div className="about-hero-btns">
            <button className="btn-cv" onClick={() => navigate('/contact')}>
              Contact me!
            </button>
            <button className="btn-ghost" onClick={() => checkladiesclick()}>
              {contactladiestext}
            </button>
          </div>
        </div>
      </section>

      <section className="about-profile">
        <div className="container about-profile-grid">
          <div className="about-avatar-wrap">
            <div className="about-avatar-ring">
              <img src={icons.profilepicture} alt="Jaylano van der Veen" className="avatar-photo" />
            </div>
          </div>
          <div className="about-info">
            <h2>Jaylano van der Veen</h2>
            <p className="about-role-label">Software Developer & Designer</p>
            <p className="about-bio">
              Currently i am studying Software Development in the Netherlands and working on websites web applications in my free time. My speciality lies in frontend development! I love building interfaces that look good and work well.
            </p>
            <p className="about-bio">
              In my free time I love to go to the gym, skate, work on websites and am busy with my own <strong>SimpleMC</strong> project.
            </p>
            <div className="about-details">
              <div className="detail-item">
                <span className="detail-label">Location</span>
                <span className="detail-val">Netherlands, Almelooooo

                </span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Email</span>
                <span className="detail-val">jaylanovanderveen.work@gmail.com</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Website</span>
                <span className="detail-val">jaylanovanderveen.nl</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Status</span>
                <span className="detail-val available">
                  Looking for work
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
}
